import { environment } from '../../../environments/environment';
import { isPubliclyFetchableUrl } from '../../_core/utils/public-origin.utils';

export abstract class CloudinaryTransformPipe {
	readonly cloudinaryCloudName: string = environment.cloudinaryCloudName;

	readonly paramsMap = {
		width: 'w_',
		height: 'h_',
		mode: 'c_',
		gravity: 'g_',
		startOffset: 'so_',
		endOffset: 'eo_',
		duration: 'du_',
		crop: 'c_',
		x: 'x_',
		y: 'y_'
	};

	abstract type: 'video' | 'image';

	transform(assetPath: string, params: any): any {
		if (assetPath?.startsWith('data:') || !params || Object.keys(params).length == 0) return assetPath;

		// Cloudinary serves a `fetch` URL by pulling the asset from its origin, so an origin only
		// this browser can resolve answers 400 and the page shows a broken image. The browser can
		// load those directly, so hand the path back untransformed and let it. See
		// isPubliclyFetchableUrl for why this is decided per URL and not from `environment.local`.
		if (!isPubliclyFetchableUrl(assetPath)) return assetPath;

		let transformations: string[] = [];

		for (let key of Object.keys(params)) {
			if (this.paramsMap[key]) {
				transformations.push(this.paramsMap[key] + params[key]);
			}
		}

		let joinedTransformations = `${transformations.join(',')}${transformations.length > 0 ? '/' : ''}`;
		let qualityOptimization = params.quality ? `${params.quality}/` : '';
		let advancedTransformation = params.adv ? `${params.adv}/` : '';

		let path = `https://res.cloudinary.com/${environment.cloudinaryCloudName}/${this.type}/fetch/${joinedTransformations}${qualityOptimization}${advancedTransformation}${assetPath}`;

		// Don't use fetch is the asset path is already a cloudinary path.
		if (assetPath && assetPath.includes('res.cloudinary.com')) {
			// Insert the transformations right after the 'upload' part of the image path.
			const parts = assetPath.split('/');
			const uploadIndex = parts.findIndex(part => part === 'upload');

			let transformations = `/${joinedTransformations}${qualityOptimization}${advancedTransformation}`;

			parts.splice(uploadIndex + 1, 0, transformations);

			path = parts.join('/');
		}

		if (environment.cloudinaryProxyUrl) {
			return `${environment.cloudinaryProxyUrl}${path}`;
		} else {
			return path;
		}
	}
}
